import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32848314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "field-group md:flex-row flex-column gap-2" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "Pacienți pe oră", -1))
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "Preț consultație", -1))
const _hoisted_8 = { class: "input-wrapper" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "Număr caractere", -1))
const _hoisted_12 = { class: "input-wrapper" }

import CustomNumberField from '@/components/forms/fields/CustomNumberField.vue';
import { DoctorConfig } from '@/interfaces/DoctorConfig';
import { PropType, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorConfig',
  props: {
  modelValue: {
    type: Object as PropType<DoctorConfig>,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;

const thisDoctorConfig = ref<DoctorConfig>(
  props.modelValue || ({} as DoctorConfig)
);

watch(
  () => props.modelValue,
  (newValue) => {
    thisDoctorConfig.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CustomNumberField, {
            id: "patientsPerHour",
            modelValue: thisDoctorConfig.value.patientsPerHour,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisDoctorConfig.value.patientsPerHour) = $event)),
            placeholder: "Pacienți pe oră",
            min: 0,
            max: 200
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CustomNumberField, {
            id: "consultationPrice",
            modelValue: thisDoctorConfig.value.consultationPrice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((thisDoctorConfig.value.consultationPrice) = $event)),
            placeholder: "Preț consultație",
            currency: "RON"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(CustomNumberField, {
            id: "charactersLimit",
            modelValue: thisDoctorConfig.value.charactersLimit,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((thisDoctorConfig.value.charactersLimit) = $event)),
            placeholder: "Număr caractere",
            mode: "integeronly"
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})